<!--  -->
<template>
  <div>
    <div class>
      <Steps :active="2" :space="'20%'" align-center>
        <Step :title="$t('cert.baseinfo')" @click.native="on_click('certbase')" />
        <Step :title="$t('cert.ralacourse')" @click.native="on_click('certcourse')" />
        <Step :title="$t('cert.certtemplaterule')" @click.native="on_click('certrule')" />
        <Step
          :title="$t('cert.recertrule')"
          v-if="dataForm.recertFlag == '10'"
          @click.native="on_click('certrerule')"
        />
        <Step
          :title="$t('cert.certassessmentdate')"
          v-if="dataForm.isCompensation == '10'"
          @click.native="on_click('certreassessment')"
        />
      </Steps>
    </div>
    <div style="margin-top:20px; margin-bottom: 20px;"></div>
    <el-card class="aui-card--fill" shadow="never">
      <!-- 认证获得年 -->
      <el-row style="border-bottom: 1px dotted #b4bccc; margin-bottom: 20px;">
        <el-col :span="3">
          <div class="div-year-tip" style="line-height: 30px;">
            <span class="el-input__prefix">
              <em class="el-input__icon el-icon-date"></em>
            </span>
            <span style="margin-left:35px; margin-right: 10px;">{{ $t('cert.certYear') }}</span>
          </div>
        </el-col>
        <el-col :span="1" style="margin-left:115px;">
          <el-button
            @click="goLeft"
            type="primary"
            style="width:30px;height:30px;padding:0 !important;float:right;margin-right:5px;background-color:#169bd5 !important;"
          >
            <em class="el-icon-arrow-left"></em>
          </el-button>
        </el-col>
        <el-col :span="16">
          <div style="word-break:keep-all; white-space:nowrap;">
            <div
              ref="certYearBar"
              style="line-height: 30px; height:47px; width:100%; overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;"
            >
              <template v-for="(item, index) in certYearArr">
                <div
                  :key="index"
                  style="border: 1px solid #dcdfe6;"
                  :class="{'div-year-before' : item < currentYear, 'div-year-after' : item >= currentYear, 'div-year-current' : item == dataForm.selectYear }"
                  @click="changeYear(item)"
                >
                  <span>{{ item }}</span>
                </div>
              </template>
            </div>
          </div>
        </el-col>
        <el-col :span="1">
          <el-button
            @click="goRight"
            type="primary"
            style=" width: 30px;
              height: 30px;
              padding: 0 !important;
              margin-left: 5px;
              background-color: #169bd5 !important;"
          >
            <em class="el-icon-arrow-right"></em>
          </el-button>
        </el-col>
        <el-col :span="3">
          <!-- <el-button type="primary" :disabled="true">{{ $t('cert.addCertYear') }}</el-button> -->
        </el-col>
      </el-row>
      <!-- 认证规则 -->
      <div class="page_title">{{ $t('cert.certRule') }}</div>
      <el-form
        label-position="top"
        label-width="auto"
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
      >
        <el-row :gutter="0">
          <!-- 认证有效期 -->
          <el-col :span="6">
            <el-form-item prop="validPeriod">
              <span style="color:#f56c6c;">*&nbsp;</span>
              {{$t('cert.validPeriod')}}
              <el-select
                v-model="dataForm.validPeriod"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item,index) in validPeriodArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 是否需要延续 -->
          <el-col :span="6">
            <el-form-item prop="recertFlag">
              <span style="color:#f56c6c;">*&nbsp;</span>
              {{$t('cert.recertFlag')}}
              <!-- <el-tooltip :content="$t('cert.recertFlagTips')" placement="bottom" effect="light"> -->
              <el-select
                v-model="dataForm.recertFlag"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item,index) in recertFlagArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <!-- </el-tooltip> -->
            </el-form-item>
          </el-col>
          <!-- 是否需要补考 -->
          <el-col :span="6">
            <el-form-item prop="aMakeUpExam">
              <span style="color:#f56c6c;">*&nbsp;</span>
              {{$t('cert.aMakeUpExam')}}
              <!-- <el-tooltip :content="$t('cert.recertFlagTips')" placement="bottom" effect="light"> -->
              <el-select
                v-model="dataForm.isCompensation"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              >
                <el-option
                  v-for="(item,index) in recertFlagArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select>
              <!-- </el-tooltip> -->
            </el-form-item>
          </el-col>
          <!-- 补考至 -->
          <el-col
            :span="6"
            v-if="dataForm.isCompensation === '10' ? true : false"
            class="aMakeUpExamColClass"
          >
            <el-form-item>
              <div>
                <span style="color:#f56c6c;">&nbsp;</span>
              </div>
              <div>
                <el-radio-group
                  v-model="dataForm.autoRecert"
                  :disabled="true"
                  @change="radioChangeFunction"
                  class="aMakeUpExamChangeClass"
                >
                  <el-radio :label="10">{{$t('cert.automaticContinuation')}}</el-radio>
                  <el-radio :label="20">{{$t('cert.makeUpExaminationTo')}}</el-radio>
                </el-radio-group>
                <el-select
                  v-model="dataForm.currentYearDate"
                  :disabled="true"
                  style="width: 100px !important;"
                  @change="selectCurrentYearChange"
                >
                  <el-option
                    v-for="(item,index) in currentYearDateArray"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
                <span>{{$t('cert.particularYear')}}</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="dataForm.isCompensation === '10' ? true : false">
          <el-col :span="6">
            <el-form-item>
              <!-- <span style="color:#f56c6c;">*&nbsp;</span> -->
              {{$t('cert.maximumExtensionDeadline')}}
              <!-- <el-select
                v-model="dataForm.validPeriod"
                :disabled="dataForm.selectYear < currentYear"
                :placeholder="$t('cert.selectTips')"
                @change="validPeriodChange"
              >
                <el-option
                  v-for="(item,index) in validPeriodArr"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                ></el-option>
              </el-select> -->
              <el-input v-model="dataForm.maximumExtensionDeadline" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="border-bottom: 1px dotted #b4bccc;">
          <div style="margin-bottom: 10px;">{{ $t('cert.certTemplate') }}</div>
        </el-row>
        <!-- 选择证书模板 -->
        <el-row :gutter="0">
          <el-col :span="6">
            <el-form-item prop="templateName">
              <span slot="label" style="display: inline-block">
                <div class="link-type">{{ $t('cert.selectTemplate')}}</div>
              </span>
              <el-input
                v-model="dataForm.templateName"
                :disabled="true"
                :placeholder="$t('cert.selectTips')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="text-align:right;">
      <el-row :gutter="0">
        <el-col :span="24"></el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="24">
          <!--  TODO: 是否延续的状态判断暂时应用的是固定10 20 -->
          <el-button
            @click="next"
            v-if="dataForm.recertFlag == '10'"
            type="primary"
          >{{ $t('cert.next') }}</el-button>
          <el-button
            @click="close"
            v-if="dataForm.recertFlag != '10'"
            type="primary"
          >{{ $t('cert.return') }}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import courseTeamCatalogtree from "../../common/courseTeamCatalogtree";
import Steps from "../../common/steps/index";
import Step from "../../common/steps/src/step";
import ZElButton from "../../common/button/index";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: { courseTeamCatalogtree, Steps, Step, ZElButton },
  props: {
    requiredData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      validPeriodArr: this.enums["validPeriod"],
      recertFlagArr: this.enums["CouresYesNoFlag"],
      currentYear: 2019,
      certYearArr: [],
      currentYearDateArray: [],
      dataForm: {
        certId: "",
        annual: "",
        selectYear: 2019,
        certRuleInfoId: "",
        validPeriod: "",
        expiryDate: "",
        recertFlag: "",
        templateId: "",
        templateName: "",
        aMakeUpExam: "20",
        currentYearDate: "",
        radio: 3,
        isCompensation: '',
        compensationFlag: '',
        comAnnualFlag: '',
        autoRecert: '',
        maximumExtensionDeadline: ''
      },
      dataRule: {
        // validPeriod: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.validPeriod'), trigger: 'change' }],
        // recertFlag: [{ required: true, message: this.$t('cert.selectTips') + this.$t('cert.recertFlag'), trigger: 'change' }]
      }
    };
  },

  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log('created')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log('mounted')
  },
  beforeCreate() {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount() {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate() {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated() {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy() {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed() {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated() {
    console.log('activated')
  },

  // 方法集合
  methods: {
    initStep() {
      this.dataForm.recertFlag = this.requiredData.recertFlag;
    },
    init() {
      this.currentYear = this.requiredData.currentYear;
      this.dataForm.selectYear = this.requiredData.selectYear;
      this.dataForm.annual = this.requiredData.selectYear;
      this.certYearArr = this.requiredData.certYearArr;
      this.dataForm.certId = this.requiredData.certId;
      this.onLoadData(this.requiredData.certId, this.requiredData.selectYear);
      this.getCurrentYearData();
    },
    on_click(stepname) {
      if (stepname === "certrule") {
        return false;
      }
      this.$emit("onShowModer", stepname);
    },
    selectCurrentYearChange() {
      console.log('selectCurrentYearChange')
    },
      goLeft() {
      let left = this.$refs.certYearBar.scrollLeft;
      this.$refs.certYearBar.scrollLeft = left - 200;
    },
    goRight() {
      let left = this.$refs.certYearBar.scrollLeft;
      this.$refs.certYearBar.scrollLeft = left + 200;
    },
    radioChangeFunction() {
      console.log('radioChangeFunction')
    },
    changeYear(year) {
      if (this.dataForm.selectYear === year) {
        return false;
      }
      this.dataForm.selectYear = year;
      this.dataForm.annual = year;
      this.onCallBack();
      this.onLoadData(this.dataForm.certId, year);
    },
    addCertYear() {
      this.certYearArr.push(this.certYearArr[this.certYearArr.length - 1] + 1);
      this.onCallBack();
    },
    getCurrentYearData() {
      this.currentYearDateArray = [];
      const currentDate = new Date();
      // const currentYearDate = currentDate.getFullYear();
      // console.log(currentYearDate);
      const currentYearObject = {
        name: this.currentYear,
        code: this.currentYear
      };
      this.currentYearDateArray.push(currentYearObject);
      // this.dataForm.currentYearDate = this.currentYear;
    },
    onCallBack() {
      this.$emit("onCallback", {
        selectYear: this.dataForm.selectYear,
        certYearArr: this.certYearArr
      });
    },
    onLoadData(certId, annual) {
      this.$request
        .post(`/learning/certinfo/queryCertRuleInfo`, {
          certId: certId,
          annual: annual
        })
        .then((res, total, code, data) => {
          this.dataForm.currentYearDate = data.data.comAnnualRecert;
          this.dataForm.certRuleInfoId = data.data.certRuleInfoId;
          this.dataForm.validPeriod = data.data.validPeriod;
          this.dataForm.recertFlag = data.data.recertFlag;
          this.dataForm.isCompensation = data.data.isCompensation.toString();
          this.dataForm.compensationFlag = data.data.compensationFlag;
          this.dataForm.comAnnualFlag = data.data.comAnnualFlag;
          this.dataForm.maximumExtensionDeadline = data.data.comMaxClosingDate
          this.dataForm.autoRecert = parseInt(data.data.autoRecert, 10);
          if (data.data.validPeriod === null) {
            // 默认为否
            this.dataForm.recertFlag = "20";
          }
          this.dataForm.templateId = data.data.templateId;
          this.dataForm.expiryDate = data.data.expiryDate;
          this.dataForm.templateName = data.data.templateName;
        })
        .catch((err) => {
          console.log(err)
        });
    },
    close() {
      this.tabRemove();
    },
    next() {
      this.$emit("onShowModer", "certrerule");
    },
    // 删除当前页面
    tabRemove() {
      let tabName = this.$store.state.contentTabsActiveName;
      if (tabName === "home") {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(
        item => item.name !== tabName
      );
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName =
          "home";
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: this.$store.state.contentTabs[
            this.$store.state.contentTabs.length - 1
          ].name
        });
      }
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
// @import url(); 引入公共css类
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: no-drop;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
.div-year-tip {
  border-width: 0px;
  position: absolute;
  background-color: #c0c4cc;
  color: #ffffff;
}
.el-input__icon {
  color: #ffffff;
}
.div-year-before {
  border-width: 0px;
  background-color: rgba(172, 167, 167, 1);
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-current {
  border-width: 0px;
  background-color: rgba(255, 176, 23, 1) !important;
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.div-year-after {
  border-width: 0px;
  background-color: rgba(22, 155, 213, 1);
  color: #ffffff;
  display: inline-block;
  width: 50px;
  text-align: center;
}
.ml_115p {
  margin-left: 115px;
}
.div-year-before:hover,
.div-year-current:hover,
.div-year-after:hover {
  cursor: pointer;
}

.aMakeUpExamChangeClass label {
  margin-right: 5px;
}

.aMakeUpExamColClass .el-form-item {
  width: 100% !important;
}
</style>
